export enum CampaignStatus {
  Active,
  Pending,
  Stopped,
}
